<app-table
    tableKey="dashboardDebtors"
    [gridData]="store.data.getSocialBillingDocumentDebtors()"
    [hideCheckboxes]="true"
    [columns]="columns()"
    [translatePrefix]="prefix"
    [showClearFilter]="false"
    [showFilters]="false"
    [showSearchBar]="false"
    [showPagination]="false"
    [additionalFilter]="additionalFilter()"
    [rowExpansion]="rowExpansion"
    [refreshCallback]="store.api.getSocialBillingDocumentDebtors"
    [refreshCallbackFragment]="fragment"
>
    <ng-template pTemplate="debt" let-data="data">
        <div class="text-danger font-bold">
            {{ data | formatNumber: 2: true }} Kč
        </div>
    </ng-template>

    <ng-template #rowExpansion let-item="item">
        <div role="table">
            <div class="debtor-documents-row font-bold" role="row">
                <div role="columnheader"></div>
                <div role="columnheader">{{ prefix + 'detail.client' | translate }}</div>
                <div role="columnheader">{{ prefix + 'detail.issueDate' | translate }}</div>
                <div class="justify-self-end" role="columnheader">{{ prefix + 'detail.debt' | translate }}</div>
            </div>

            @for (document of item.documents; track document.id) {
                <div class="debtor-documents-row" role="row">
                    <div role="cell">
                        <app-button
                            icon="pi-folder-open"
                            [text]="true"
                            styleClass="billingIcon"
                            (clickEvent)="openBilling(item.folderId, document.id)">
                        </app-button>
                    </div>
                    <div role="cell">
                        <app-user-chip
                            [user]="item.person"
                            [renderType]="UserChipRenderTypeEnum.Client"
                            [renderDetails]="false"
                            [sortDetails]="true"
                        ></app-user-chip>
                    </div>
                    <div role="cell">{{ document.issueDate | localDate: 'd.M.y' }}</div>
                    <div class="text-danger font-bold justify-self-end" role="cell">
                        {{ document.debt | formatNumber: 2: true }} Kč
                    </div>
                </div>
            }
        </div>
    </ng-template>
</app-table>
